export default __webpack_public_path__ + "static/media/Price.c5e3b5cc.png";